export interface Theme {
  headerColor: string;
  evenColor: string;
  oddColor: string;
  secondaryFooterColor?: string;
  footerColor: string;
}

export interface BorderStyle {
    id: number
    name: string
}


export const colorWithHeader: Theme[] = [
  {
    "headerColor": "rgb(189, 189, 189)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(243, 243, 243)",
    "secondaryFooterColor": "rgb(222, 222, 222)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(77, 208, 225)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(224, 247, 250)",
    "secondaryFooterColor": "rgb(162, 232, 241)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(99, 210, 151)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(231, 249, 239)",
    "secondaryFooterColor": "rgb(175, 233, 202)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(247, 203, 77)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(254, 248, 227)",
    "secondaryFooterColor": "rgb(252, 232, 178)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(244, 101, 36)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(255, 230, 221)",
    "secondaryFooterColor": "rgb(255, 204, 188)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(91, 149, 249)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(232, 240, 254)",
    "secondaryFooterColor": "rgb(172, 201, 254)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(38, 166, 154)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(221, 242, 240)",
    "secondaryFooterColor": "rgb(140, 211, 205)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(120, 144, 156)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(235, 239, 241)",
    "secondaryFooterColor": "rgb(187, 200, 206)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(204, 166, 119)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(248, 242, 235)",
    "secondaryFooterColor": "rgb(230, 211, 186)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(139, 195, 74)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(238, 247, 227)",
    "secondaryFooterColor": "rgb(196, 226, 160)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(137, 137, 235)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(232, 231, 252)",
    "secondaryFooterColor": "rgb(196, 195, 247)",
    "footerColor": "rgb(255, 255, 255)"
  },
  {
    "headerColor": "rgb(233, 29, 99)",
    "evenColor": "rgb(255, 255, 255)",
    "oddColor": "rgb(253, 220, 232)",
    "secondaryFooterColor": "rgb(246, 138, 176)",
    "footerColor": "rgb(255, 255, 255)"
  }
];


export const colorWithOutHeader: Theme[]  = [
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(243, 243, 243)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(243, 243, 243)",
    "secondaryFooterColor": "rgb(222, 222, 222)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(224, 247, 250)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(224, 247, 250)",
    "secondaryFooterColor": "rgb(162, 232, 241)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(231, 249, 239)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(231, 249, 239)",
    "secondaryFooterColor": "rgb(175, 233, 202)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(254, 248, 227)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(254, 248, 227)",
    "secondaryFooterColor": "rgb(252, 232, 178)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(255, 230, 221)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(255, 230, 221)",
    "secondaryFooterColor": "rgb(255, 204, 188)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(232, 240, 254)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(232, 240, 254)",
    "secondaryFooterColor": "rgb(172, 201, 254)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(221, 242, 240)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(221, 242, 240)",
    "secondaryFooterColor": "rgb(140, 211, 205)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(235, 239, 241)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(235, 239, 241)",
    "secondaryFooterColor": "rgb(187, 200, 206)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(248, 242, 235)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(248, 242, 235)",
    "secondaryFooterColor": "rgb(230, 211, 186)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(238, 247, 227)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(238, 247, 227)",
    "secondaryFooterColor": "rgb(196, 226, 160)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(232, 231, 252)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(232, 231, 252)",
    "secondaryFooterColor": "rgb(196, 195, 247)",
  },
  {
    "headerColor": "rgb(255, 255, 255)",
    "evenColor": "rgb(253, 220, 232)",
    "oddColor": "rgb(255, 255, 255)",
    "footerColor": "rgb(253, 220, 232)",
    "secondaryFooterColor": "rgb(246, 138, 176)",
  }
];